import { Component, Input } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { NoDataComponent } from '../no-data/no-data.component';
import { CommonModule } from '@angular/common';
import { NotFoundPageComponent } from '../not-found-page/not-found-page.component';
import { LoadingService } from '../../../../@AppService/Services/loader-service.service';
import { ActivatedRoute } from '@angular/router';
interface pageFallback {
  title: string;
  message: string;
  img: string;
}

type FallbackType =
  | 'pageNotFound'
  | 'serverError'
  | 'noData'
  | 'noEvents'
  | 'noPhotos'
  | 'noVideos';
@Component({
  selector: 'app-fallback',
  standalone: true,
  imports: [NoDataComponent, CommonModule, NotFoundPageComponent],
  templateUrl: './fallback.component.html',
  styleUrl: './fallback.component.scss',
})
export class FallbackComponent {
  @Input() type!: FallbackType;
  @Input() isButton: boolean = true;
  fallbackData!: pageFallback;

  constructor(
    private translateService: TranslateService,
    private loadingService: LoadingService,
    private route: ActivatedRoute
  ) {}
  ngOnInit() {
    // **Subscribe to error state**
    this.loadingService.isError.subscribe((res) => {
      if (res) {
        this.type = 'serverError';
      } else {
      }
      // this.type = res ? 'serverError' : 'noData';
      this.updateFallbackData();
    });

    // **Get the type parameter from the route**
    this.route.data.subscribe((data) => {
      if (data['type']) {
        this.type = data['type'] as FallbackType;
        this.updateFallbackData();
      }
    });

    if (!this.type) {
      this.type = 'noData';
      this.updateFallbackData();
    }
    // **Initialize fallback data**
  }

  private updateFallbackData(): void {
    const fallbackMapping: Record<FallbackType, pageFallback> = {
      pageNotFound: {
        title: this.translateService.instant('fallback.errorTitle'),
        message: this.translateService.instant(
          'fallback.errorNotFoundSubTitle'
        ),
        img: 'assets/images/404-error.svg',
      },
      serverError: {
        title: this.translateService.instant('fallback.errorTitle'),
        message: this.translateService.instant('fallback.serverErrorSubTitle'),
        img: 'assets/images/server-error.avif',
      },
      noData: {
        title: this.translateService.instant('fallback.noResultTitle'),
        message: this.translateService.instant('fallback.noResultSubTitle'),
        img: 'assets/images/notfound-error.svg',
      },
      noEvents: {
        title: this.translateService.instant('fallback.noEvents'),
        message: '',
        img: 'assets/images/noEvents.svg',
      },
      noPhotos: {
        title: this.translateService.instant('fallback.noPhotos'),
        message: '',
        img: 'assets/images/noEvents.svg',
      },
      noVideos: {
        title: this.translateService.instant('fallback.noVideos'),
        message: '',
        img: 'assets/images/noEvents.svg',
      },
    };

    this.fallbackData = fallbackMapping[this.type];
  }
}
